
import {useLayoutEffect } from 'react'


export default function ParticleEffect(props) {
   
    useLayoutEffect(() => {


        var fluid = new window.Fluid("fluid_container",{
            PARTICLES_TOTAL: 200,
				PARTICLE_TYPES_TOTAL: 131,
				PARTICLE_DEPTHS_TOTAL: 11,							
				FLUID_VISCOSITY: 0.5,
				PARTICLE_SENSITIVITY: 0.5, 
				PARTICLE_DISTURBANCE_INTENSITY: 20, 
				PARTICLE_DISTURBANCE_FREQUENCY: 50,
				PARTICLE_SIZE:  5, 
				PARTICLE_THICKNESS: 0.7, 
				PARTICLE_CURVATURE: 1, 
				PARTICLE_COLORS: ["white", "#abfaff", "#bdfffb"], 
				PARTICLE_VISIBILITY_MIN: 0.13, 
				PARTICLE_VISIBILITY_MAX: 1, 
				PARTICLE_VISIBILITY_CURVE: 0.3,							

            
        });

        console.log(fluid)


    }, [])// eslint-disable-line react-hooks/exhaustive-deps

       

    return (

        <div
            style={{
        
                width:'100vw',
                height:'100vh',
                position: 'fixed',

            }}
            id="fluid_container"
        
        >

            <div
                style={{
                    opacity: '0.12',
                    position: 'fixed',
                    top: '0',
                    bottom: '0',
                    left: '40',
                    right: '50%',
                    display: 'block',
                    height: '5vh',
                    width: '5vh',
                    margin: 'auto',
                    borderRadius: '50%',
                    background: '#fff',
                    boxShadow: '0 0 50vh 40vh #fff',     
                    zIndex:'999'
                    
                            
                }}
            
            >

            </div>            
        </div>
    )
}
